





















import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class'
import * as types from '@/store/content/types'
import Content from '@/store/models/content'
import { Route } from 'vue-router'
import VContentList from '@/components/VContentList.vue'
import VLoader from '@/components/VLoader.vue'
import VButton from '@/components/VButton.vue'
import FilterMenu from '@/components/FilterMenu.vue'

@Component({ components: { FilterMenu, VButton, VContentList, VLoader } })
export default class ContentView extends Vue {
  @Action('content', { namespace: 'content' }) getContent!: types.ContentAction
  @Mutation('EMPTY_SEARCH_TAGS', { namespace: 'content' }) emptySearchTags!: types.EmptySearchTags
  @Mutation('EMPTY_FILTERS', { namespace: 'content' }) emptyFilters!: types.EmptyFilters
  @Getter('bookTree', { namespace: 'content' }) bookTree!: types.BookTree

  private content: { [contentType: string]: Content[] } = {}
  private unsubscribe!: () => void
  private loading = true
  private title = ''

  private created () {
    this.emptySearchTags()
    this.emptyFilters()
    this.loadContent(this.$route)
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'content/SET_SEARCH_TAGS' ||
        mutation.type === 'content/TOGGLE_FILTER' ||
        mutation.type === 'content/SET_ONLY_FAVORITES') {
        this.loadContent(this.$route)
      }
    })
  }

  private beforeDestroy () {
    this.unsubscribe()
  }

  @Watch('$route')
  private loadContent (newRoute: Route) {
    this.loading = true
    this.getContent({ categoryId: newRoute.params.category, bookId: newRoute.params.id }).then((response) => {
      this.content = response.content
      if (response.category !== undefined) {
        this.title = response.category.name + ' ' + response.category.description
      } else {
        this.title = this.bookTree.book.name
      }
    }).finally(() => {
      this.loading = false
    })
  }
}
